const state = {
    user: {
        name:'',
        id:''
    },
	baseUrl:'http://weixinapi.cvddr.com'
    // baseUrl:'http://weixinapi-test.cvddr.com'
	// baseUrl:'http://jxapi-test.cvddr.cn'
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js